import { useEffect, useRef } from "react";
import Lenis from "lenis";

/**
 * Smooth momentum scroll wrapper.
 * Uses Lenis to add subtle inertia to page scroll.
 */
export default function SmoothScroll({ children }) {
  const rafRef = useRef(null);
  useEffect(() => {
    // Respect users who ask for reduced motion.
    if (typeof window !== "undefined" && window.matchMedia?.("(prefers-reduced-motion: reduce)").matches) return;
    const lenis = new Lenis({
      duration: 1.25,
      easing: (t) => Math.min(1, 1.001 - Math.pow(2, -10 * t)),
      smoothWheel: true,
      smoothTouch: false,
    });
    const raf = (time) => { lenis.raf(time); rafRef.current = requestAnimationFrame(raf); };
    rafRef.current = requestAnimationFrame(raf);
    // Hash link support (e.g. #lead)
    const onHash = (e) => {
      const a = e.target.closest?.("a[href^='#']");
      if (!a) return;
      const id = a.getAttribute("href");
      if (!id || id.length < 2) return;
      const el = document.querySelector(id);
      if (el) { e.preventDefault(); lenis.scrollTo(el, { offset: -72 }); }
    };
    document.addEventListener("click", onHash);
    return () => {
      document.removeEventListener("click", onHash);
      cancelAnimationFrame(rafRef.current);
      lenis.destroy();
    };
  }, []);
  return children;
}
